import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const PATHS = {
  SETTINGS: '/settings',
  MFA_SETUP: '/settings/mfa/setup',
  ONBOARDING: '/onboarding',
  DASHBOARD: '/dashboard',
};

const EXEMPT_PATHS = [PATHS.SETTINGS, PATHS.MFA_SETUP, PATHS.ONBOARDING];

const FinishRegistrationRedirect = ({ children }) => {
  const { currentUser, userProfile } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!currentUser || !userProfile) return;

    // Don't redirect if we're on exempt pages
    if (EXEMPT_PATHS.includes(location.pathname)) {
      return;
    }

    // const providerIds = currentUser.providerData.map((provider) => provider.providerId);
    // const isGoogleUser = providerIds.includes(PROVIDER_IDS.GOOGLE);
    // const isEmailPasswordUser = providerIds.includes(PROVIDER_IDS.EMAIL_PASSWORD);
    // const hasPhoneLinked = !!currentUser.phoneNumber;
    const hasEmailLinked = !!currentUser.email || !!userProfile.email;
    const hasUsername = !!userProfile.username;
    const hasHomeClub = !!userProfile.homeClub;

    if (!hasEmailLinked || !hasUsername || !hasHomeClub) {
      navigate(PATHS.ONBOARDING);
      return;
    }

    // Handle Google users - require phone linking
    // if (isGoogleUser && !hasPhoneLinked) {
    //   navigate(PATHS.SETTINGS, {
    //     state: {
    //       showAlert: true,
    //       message: "Please link your phone number to your Wagl account."
    //     }
    //   });
    //   return;
    // }

    // Handle Email/Password users - require email verification, phone linking, and MFA
    // if (isEmailPasswordUser) {
    //   const emailVerified = currentUser.emailVerified;

    //   // First check if email is verified
    //   // if (!emailVerified) {
    //   //   navigate(PATHS.SETTINGS, {
    //   //     state: {
    //   //       showAlert: true,
    //   //       message: "Please verify your email address.",
    //   //     }
    //   //   });
    //   //   return;
    //   // }

    //   // Then check if phone is linked
    //   // if (!hasPhoneLinked) {
    //   //   navigate(PATHS.SETTINGS, {
    //   //     state: {
    //   //       showAlert: true,
    //   //       message: "Please link your phone number to your Wagl account."
    //   //     }
    //   //   });
    //   //   return;
    //   // }

    //   // Finally check MFA
    //   // try {
    //   //   const multiFactorUser = multiFactor(currentUser);
    //   //   const hasMfa = multiFactorUser.enrolledFactors.length > 0;

    //   //   if (!hasMfa) {
    //   //     navigate(PATHS.SETTINGS, {
    //   //       state: {
    //   //         showAlert: true,
    //   //         message: "Please set up two-factor authentication to secure your account."
    //   //       }
    //   //     });
    //   //     return;
    //   //   }
    //   // } catch (error) {
    //   //   console.error("Error checking MFA status:", error);
    //   // }
    // }
  }, [currentUser, navigate, location.pathname, userProfile]);

  return children;
};

export default FinishRegistrationRedirect;
